import {Component, OnInit, ViewChild} from '@angular/core';
import {VnaCampaignActionService} from '../../services/vna-campaign-action.service';
import {ActivatedRoute} from '@angular/router';

import {Observable} from 'rxjs/Rx';
import {MiscelaneaService} from '../../../../../shared/services/miscelanea.service';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';

@Component({
  selector: 'app-action-reporting',
  templateUrl: './action-reporting.component.html',
  styleUrls: ['./action-reporting.component.scss']
})
export class ActionReportingComponent implements OnInit {

    reports: Array<Object> = [];
    loading: boolean = false;
    actionData: Object = {};

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 5;

    pkAction: number;
    trackingKey: string = '';

    generatingReport: boolean = false;
    progress: Object;

    @ViewChild(PaginationComponent) pagination: PaginationComponent;

    constructor(private campActionService: VnaCampaignActionService, private route: ActivatedRoute, private misc: MiscelaneaService) {
        this.initProgress();
    }

    ngOnInit() {
        this.route.params.subscribe( (params) => {
            this.pkAction = params['pkAction'];
            this.loading = true;

            Observable.forkJoin(
                this.campActionService.findMergedActionCampaign(this.pkAction),
                this.campActionService.findActionReportings(this.pkAction)
            ).subscribe(
                (r) => {
                    this.actionData = r[0];
                    this.reports = r[1];
                    this.endAt = (!this.haveToPaginate()) ? this.reports.length : this.perPage;
                    this.loading = false;
                }
            )
        });
    }

    haveToPaginate(): boolean {
        return this.perPage < this.reports.length;
    }

    goToPage(n: number) {
        this.startAt = (this.pagination) ? this.pagination.getStart() : 0;
        this.endAt = (this.pagination) ? this.pagination.getEnd() : this.perPage;

    }

    getWidth(value){
        return value + '%';
    }

    generateNewReport(): void {

        this.generatingReport = true;
        this.initProgress();

        this.campActionService.createReport(this.pkAction).subscribe(
            (r) => {
                this.trackingKey = r['tracking_key'];
                let interval = setInterval( () => {
                    this.misc.checkProgress(this.trackingKey, 'master').subscribe(
                        (p) => {
                            if(p.hasOwnProperty('status_general') && p['status_general'] == 'Finished'){
                                clearInterval(interval);
                                this.generatingReport = false;
                                this.loading = true;
                                this.campActionService.findActionReportings(this.pkAction).subscribe(
                                    (reports) => {
                                        this.reports = reports;
                                        this.loading = false;
                                    }
                                )
                            }

                            if(p.hasOwnProperty('progress_found')) this.progress['progress_found'] = p['progress_found'];
                            if(p.hasOwnProperty('progress_remaining')) this.progress['progress_remaining'] = p['progress_remaining'];
                            if(p.hasOwnProperty('status_general')) this.progress['status_general'] = p['status_general'];

                        }
                    )
                }, 5000)
            }
        );
    }


    protected initProgress(): void {
        this.progress = {
            'progress_found' : { 'total' : 0, 'processed' : 0, 'percent_completed' : 0, 'status' : 'pending' },
            'progress_remaining' : { 'total' : 0, 'processed' : 0, 'percent_completed' : 0, 'status' : 'pending' },
            'status_general' : 'Waiting for process start ...'
        }
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/action-reporting/action-reporting.component.ts